import { useEffect } from 'react';
import { useIssueStore } from '../store';
import { useIssuesQuery } from './useIssuesQuery';

/**
 * Reads the navigation list of the issue view for the grid's search, filters
 * and sort: once when the view opens and again when they change, not on every
 * issue the user moves to.
 */
export function useIssueIdListLoader(): void {
  const query = useIssuesQuery();
  const loadIssueIdList = useIssueStore.use.loadIssueIdList();

  useEffect(() => {
    if (query) {
      void loadIssueIdList(query);
    }
  }, [query, loadIssueIdList]);
}
